import React, {Component} from "react";
import "./style.css";

interface IFearAndGreedValueChartProps {
    data: any;
};

class FearAndGreedValueChart extends Component<IFearAndGreedValueChartProps, {}> {

    public colors = {
        'extreme fear': '#bf1e2d',
        'fear': '#f0592a',
        'neutral': '#a3a3a3',
        'greed': '#86c240',
        'extreme greed': '#35a046'
    };

    public render() {
        const data = this.props.data;
        const color = this.colors[data.valueText.toLowerCase()] || '#716565';
        const value = data.value + '%';

        return <div className="ChartContainer">
            <div className="ChartData" style={{
                left: value
            }}>
                    <div className="ChartNowText">Now</div>
                    <div className="ChartDataText" style={{
                        color
                    }}>{data.valueText}</div>
                <div className="ChartDataCircle" style={{
                    backgroundColor: color
                }}>
                    {data.value}
                </div>
            </div>
            <div className="ChartAxis"/>
            <div className="ChartValueLine"  style={{
                left: value
            }}/>
            <div className="ChartAxisMinValue"/>
            <div className="ChartAxisMiddleValue"/>
            <div className="ChartAxisMaxValue"/>
            <div className="ChartAxisMinValueLabel">0</div>
            <div className="ChartAxisMiddleValueLabel">50</div>
            <div className="ChartAxisMaxValueLabel">100</div>
            <div className="ChartAxisMinValueDescription">Extreme Fear</div>
            <div className="ChartAxisMaxValueDescription">Extreme Greed</div>
        </div>;
    }
}

export default FearAndGreedValueChart;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/FearAndGreedIndex/FearAndGreedValueChart.tsx